import { useAccordionButton } from "react-bootstrap";
import Button from "react-bootstrap/Button";

interface CustomToggle {
  className?: string;
  children: any;
  eventKey: string;
  open: any;
  setOpen: any;
  size?: "sm" | "lg";
  style?: any;
  variant?: string;
}

export default function CustomToggle(props: CustomToggle) {
  const decoratedOnClick = useAccordionButton(props.eventKey, () => props.setOpen(!props.open));

  return (
    <Button className={props.className} variant={props.variant} size={props.size} style={props.style} onClick={decoratedOnClick}>
      {props.children}
    </Button>
  );
}
